import {
    LOCALSTORAGE_MAP_STYLE,
    LOCALSTORAGE_LOCATION_REFRESH_MINUTES,
} from "../const/storage"
import {
    MAP_STYLES,
    DEFAULT_MAP_STYLE,
    LOCATION_REFRESH_OPTIONS_MINUTES,
    DEFAULT_LOCATION_REFRESH_MINUTES,
    PREFERENCES_CHANGE_EVENT,
} from "../const/preferences"

const readItem = (key) => {
    try {
        return localStorage.getItem(key)
    } catch {
        return null
    }
}

const writeItem = (key, value) => {
    try {
        localStorage.setItem(key, String(value))
    } catch {
        // Storage can be unavailable (private mode); the preference then
        // simply doesn't persist.
    }
    window.dispatchEvent(new Event(PREFERENCES_CHANGE_EVENT))
}

export const getMapStyle = () => {
    const stored = readItem(LOCALSTORAGE_MAP_STYLE)
    return MAP_STYLES.some((style) => style.value === stored)
        ? stored
        : DEFAULT_MAP_STYLE
}

export const setMapStyle = (value) => writeItem(LOCALSTORAGE_MAP_STYLE, value)

export const getLocationRefreshMinutes = () => {
    const stored = Number(readItem(LOCALSTORAGE_LOCATION_REFRESH_MINUTES))
    return LOCATION_REFRESH_OPTIONS_MINUTES.includes(stored)
        ? stored
        : DEFAULT_LOCATION_REFRESH_MINUTES
}

export const setLocationRefreshMinutes = (minutes) =>
    writeItem(LOCALSTORAGE_LOCATION_REFRESH_MINUTES, minutes)

export const readPreferences = () => ({
    mapStyle: getMapStyle(),
    locationRefreshMinutes: getLocationRefreshMinutes(),
})
